import { Slide } from '@/types/slides'

export const slides: Slide[] = [
  {
    checked:true,
    id: 'test123456',
    elements: [],
    width: 1920,
    height: 1080,
    unit:'px',
    ratio: 0.56,
    background: {
      type: 'solid',
      color: '#ffffff',
    },
    preview:{
      width: 1920,
      height: 1080,
      url:'https://st-gdx.dancf.com/gaodingx/0/uxms/design/20201228-014630-996e.png',
    },
  }
]

export const groupEle = {
  id: '123456',
  elements: [
    {
      type: 'image',
      id: 'hYe3Pa',
      src: 'https://st0.dancf.com/02/material_uploader/202108181150-6f9d.png?x-oss-process=image/format,webp',
      width: 527.2323232323232,
      height: 215.56113215488216,
      left: 288.68513392109173,
      top: 370.5227215204436,
      fixedRatio: true,
      rotate: 0,
      groupId: '3dSvnH'
    },
    {
      type: 'text',
      id: 'pONbsZ',
      left: 247.3920745881865,
      top: 405.9520144497366,
      width: 630.6471110339306,
      height: 205,
      content: '<p style="text-align: center;"><strong><span style="color: rgb(173, 105, 56);"><span style="font-size: 120px"><span style="font-family: 素材集市酷方体">快乐无价</span></span></span></strong></p>',
      rotate: 0,
      defaultFontName: 'Microsoft Yahei',
      defaultColor: '#333',
      groupId: '3dSvnH'
    },
  ]
}

